/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { FC, useContext } from "react"
import { HR, Spacer } from "../../views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { ButtonPrimary } from "../../views/atoms/buttons/ButtonPrimary"
import { SendMessageFormContext } from "./SendMessage"
import { FlexContainer, H2, H4 } from "@carrotfertility/carotene"
import { BenefitEnrollmentModalContinueButton } from "../../cmd-enrollment/shared"
import { useIntl, FormattedMessage } from "react-intl"

interface ThankYouProps {
  showHeader?: boolean
  showBottomLine?: boolean
  close?: boolean
  onClick?: () => void
  continueLink?: boolean
  sentMessageVariant?: boolean
}

const ThankYou: FC<ThankYouProps> = ({
  close = false,
  showHeader = true,
  showBottomLine = true,
  onClick = null,
  continueLink = false,
  sentMessageVariant = false
}) => {
  const intl = useIntl()
  const { personalEmail, employeeEmail, partnerEmail, sentFromPartnerEmail } = useContext(SendMessageFormContext)

  function getIntlBodyText(): any {
    if (sentMessageVariant) {
      if (sentFromPartnerEmail) {
        return intl.formatMessage(
          { defaultMessage: "We'll look into this and get back to you at {email}, your partner's email." },
          { email: partnerEmail }
        )
      } else if (personalEmail) {
        return intl.formatMessage(
          { defaultMessage: "We'll look into this and get back to you at {email}, your preferred email." },
          { email: personalEmail }
        )
      } else {
        return intl.formatMessage(
          { defaultMessage: "We'll look into this and get back to you at {email}, your account email." },
          { email: employeeEmail }
        )
      }
    } else {
      if (sentFromPartnerEmail) {
        return intl.formatMessage(
          { defaultMessage: "We’ll get back to you at {email}, your partner's email." },
          { email: partnerEmail }
        )
      } else if (personalEmail) {
        return intl.formatMessage(
          { defaultMessage: "We’ll get back to you at {email}, your preferred email." },
          { email: personalEmail }
        )
      } else {
        return intl.formatMessage(
          { defaultMessage: "We’ll get back to you at {email}, your account email." },
          { email: employeeEmail }
        )
      }
    }
  }

  return (
    <>
      {showHeader && (
        <H4>
          <FormattedMessage defaultMessage="Send a message" />
        </H4>
      )}
      <Spacer height={1.5} />
      <H2>
        {sentMessageVariant ? (
          <FormattedMessage defaultMessage="We'll take it from here." />
        ) : (
          <FormattedMessage defaultMessage="Received!" />
        )}
      </H2>
      <Spacer height={0.5} />
      <Body color="black-80">{getIntlBodyText()}</Body>
      <Spacer height={3.5} />
      {continueLink ? (
        <BenefitEnrollmentModalContinueButton onClick={onClick} />
      ) : (
        <FlexContainer justifyContent={close ? "center" : "flex-end"}>
          <ButtonPrimary onClick={onClick} to="/">
            {close ? <FormattedMessage defaultMessage="Close" /> : <FormattedMessage defaultMessage="Done" />}
          </ButtonPrimary>
        </FlexContainer>
      )}

      {showBottomLine && (
        <>
          <Spacer height={1.5} />
          <HR color="black-10" />
          <Spacer height={1.5} />
        </>
      )}
    </>
  )
}

export { ThankYou }
